import React, { useEffect, useState } from 'react';
import { auth, db } from './firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';

const RideHistoryScreen = () => {
  const [upcoming, setUpcoming] = useState([]);
  const [completed, setCompleted] = useState([]);
  const [cancelled, setCancelled] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchRides = async () => {
      const uid = auth.currentUser?.uid;
      if (!uid) return;

      const q = query(collection(db, 'riders'), where('passengerId', '==', uid));
      const snap = await getDocs(q);

      const upcomingRides = [];
      const completedRides = [];
      const cancelledRides = [];

      snap.forEach(doc => {
        const data = doc.data();
        const status = data.status?.trim().toLowerCase();
        const ride = { id: doc.id, ...data };

        if (status === 'completed') {
          completedRides.push(ride);
        } else if (['cancelled', 'cancelled_by_passenger'].includes(status)) {
          cancelledRides.push(ride);
        } else if (['accepted', 'on_route', 'arrived'].includes(status)) {
          upcomingRides.push(ride);
        }
      });

      setUpcoming(upcomingRides);
      setCompleted(completedRides);
      setCancelled(cancelledRides);
      setLoading(false);
    };

    fetchRides();
  }, [navigate]);

  const formatTimestamp = ts =>
    ts?.seconds ? new Date(ts.seconds * 1000).toLocaleString() : 'Not Scheduled';

  const renderRideCard = ride => (
    <div
      key={ride.id}
      style={{
        border: '1px solid #e5e7eb',
        borderRadius: '12px',
        padding: '16px',
        marginBottom: '16px',
        backgroundColor: '#fff',
        boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
      }}
    >
      <div style={{ marginBottom: '6px' }}>
        <strong>🚗 Driver:</strong> {ride.driverName || 'N/A'}
      </div>
      <div>
        <strong>📍 Pickup:</strong> {ride.pickupAddress}
      </div>
      <div>
        <strong>🏁 Drop-off:</strong> {ride.dropoffAddress}
      </div>
      <div>
        <strong>💰 Fare:</strong> £{(ride.calculatedFare || 0).toFixed(2)}
      </div>
      <div>
        <strong>📋 Status:</strong> {ride.status}
      </div>
      <div>
        <strong>📝 Reason:</strong> {ride.declineReason || 'N/A'}
      </div>
      <div>
        <strong>🕒 Time:</strong> {formatTimestamp(ride.scheduledTime)}
      </div>
    </div>
  );

  const renderSection = (title, rides) => (
    <section style={{ marginBottom: '2rem' }}>
      <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', borderBottom: '2px solid #e5e7eb' }}>
        {title}
      </h2>
      {rides.length === 0 ? (
        <p style={{ fontStyle: 'italic', color: '#666' }}>No rides found.</p>
      ) : (
        rides.map(renderRideCard)
      )}
    </section>
  );

  return (
    <main style={{ padding: '2rem', maxWidth: '720px', margin: '0 auto', fontFamily: 'Segoe UI, sans-serif' }}>
      <h1 style={{ marginBottom: '2rem', fontSize: '2rem', color: '#0f172a' }}>
        🧾 Your Ride History
      </h1>
      {loading ? (
        <p>Loading rides...</p>
      ) : (
        <>
          {renderSection('Upcoming Rides', upcoming)}
          {renderSection('Completed Rides', completed)}
          {renderSection('Cancelled Rides', cancelled)}
          <button
            onClick={() => navigate(-1)}
            style={{
              marginTop: '1rem',
              padding: '10px 16px',
              backgroundColor: '#0d9488',
              color: '#fff',
              border: 'none',
              borderRadius: '6px',
              fontWeight: 'bold',
              cursor: 'pointer',
              transition: 'background 0.3s',
            }}
            onMouseOver={e => (e.currentTarget.style.backgroundColor = '#0f766e')}
            onMouseOut={e => (e.currentTarget.style.backgroundColor = '#0d9488')}
          >
            ← Back
          </button>
        </>
      )}
    </main>
  );
};

export default RideHistoryScreen;